import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import AllProducts from './Pages/AllProducts';
import Men from './Pages/Men';
import Women from './Pages/Women';
// import Children from './Pages/Children';  // Uncomment if needed
import AccessoriesCollectibles from './Pages/AccessoriesCollectibles';
import ShoppingCartPage from './Pages/ShoppingCartPage';
import SizeGuide from './Pages/SizeGuide'; // Import the new SizeGuide page

function App() {
  return (
    <Router>
      <Navbar />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/all" element={<AllProducts />} />
        <Route path="/men" element={<Men />} />
        <Route path="/women" element={<Women />} />
        <Route path="/accessories_collectibles" element={<AccessoriesCollectibles />} />
        <Route path="/cart" element={<ShoppingCartPage />} />
        <Route path="/size-guide" element={<SizeGuide />} /> {/* Add route for SizeGuide page */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
